/**
 * Navegación ida/vuelta Finanzas ⇄ /caja/movimientos (detalle de métricas).
 *
 * Contrato de URL (copiable):
 *   /caja/movimientos?tenant=&period=&year=&month=&sede?&tipo?&from=finances&tenants?
 * Vuelta:
 *   /finances?tenant=&period=&year=&month=&sede?&tab=overview|movements
 */

export type CajaMovimientosTipo = 'todos' | 'ingreso' | 'egreso';

export interface CajaMovimientosNavInput {
  tenantId: string;
  year: number;
  month: number;
  /** `YYYY-MM` o anual; se incluye para el period chip global. */
  period?: string;
  sede?: number;
  tipo?: CajaMovimientosTipo;
  /** Origen para breadcrumb / volver. */
  from?: 'finances' | 'clinicHub' | 'reports';
  /** Subconjunto cuando tenantId === 'all'. */
  tenantIds?: string[];
}

export interface FinancesReturnNavInput {
  /** Omitir en vista red (multi). */
  tenantId?: string;
  year: number;
  month: number;
  period?: string;
  sede?: number;
  tab?: 'overview' | 'movements' | 'network' | 'trend' | 'plans' | 'methods';
}

function periodValue(input: { year: number; month: number; period?: string }): string {
  if (input.period) return input.period;
  return `${input.year}-${String(input.month).padStart(2, '0')}`;
}

export function buildCajaMovimientosHref(input: CajaMovimientosNavInput): string {
  const params = new URLSearchParams({
    tenant: input.tenantId,
    period: periodValue(input),
    year: String(input.year),
    month: String(input.month),
  });
  if (input.sede !== undefined) {
    params.set('sede', String(input.sede));
  }
  if (input.tipo && input.tipo !== 'todos') {
    params.set('tipo', input.tipo);
  }
  if (input.from) {
    params.set('from', input.from);
  }
  if (input.tenantId === 'all' && input.tenantIds?.length) {
    params.set('tenants', input.tenantIds.join(','));
  }
  return `/caja/movimientos?${params.toString()}`;
}

export function buildFinancesReturnHref(input: FinancesReturnNavInput): string {
  const params = new URLSearchParams({
    period: periodValue(input),
    year: String(input.year),
    month: String(input.month),
    tab: input.tab ?? 'overview',
  });
  if (input.tenantId) {
    params.set('tenant', input.tenantId);
  }
  if (input.sede !== undefined) {
    params.set('sede', String(input.sede));
  }
  return `/finances?${params.toString()}`;
}
